import { Outlet, useLocation } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './Settings.module.css';

import SimpleBar from 'simplebar-react';
import useSimpleBar from '../../hooks/useSimpleBar';

import Container from '../../components/Container';
import TopArea from '../../components/TopArea';

import { SETTINGS } from '../../constants';
import { useEffect } from 'react';
import { useAppDispatch } from '../../hooks/useRedux';
import { menuChanged } from '../../features/infoSlice';

export default function Settings() {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const [simplebarRef] = useSimpleBar();
  const { pathname } = useLocation();
  const lastPath = pathname.split('/').splice(-1)[0];
  const isNarrow = [
    'settings',
    'account',
    'profile',
    'delete',
    'storage',
    'writing-feedback',
    'membership',
    'cancel-membership',
    'change-card',
  ].includes(lastPath);

  useEffect(() => {
    dispatch(menuChanged('settings'));
  }, []);

  return (
    <Container isSubPage={true}>
      <TopArea title={SETTINGS} className="st_subpage" />
      <div className={cx('content', 'settings')}>
        <div className={cx('section')}>
          <SimpleBar forceVisible={true} ref={simplebarRef}>
            <div className={cx('setting_area', { mx_min: isNarrow }, lastPath)}>
              <Outlet></Outlet>
            </div>
          </SimpleBar>
        </div>
      </div>
    </Container>
  );
}
